/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleague_No_MatchInputs */



/**
* | output |
* | --- |
* | "Nobody found." |
*
* @param {Meetings_Colleague_No_MatchInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleague_no_match = /** @type {((inputs?: Meetings_Colleague_No_MatchInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleague_No_MatchInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niemand gevonden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun résultat.")
	return /** @type {LocalizedString} */ ("Nobody found.")
});